import { ClickEvent } from "@mcleod/components";
import { AutogenLayoutEdiTemplateQuickInfo } from "./autogen/AutogenLayoutEdiTemplateQuickInfo";
import { McLeodClassicIntegration } from "@mcleod/core";

export class EdiTemplateQuickInfo extends AutogenLayoutEdiTemplateQuickInfo {

    buttonOpenClassicOnClick(event: ClickEvent) {
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.edi.EntryEdiInstallTemplate", "<ext> search id ='" + this.mainDataSource?.activeRow?.get("id") + "'");
    }

}